module.exports = __webpack_public_path__ + "img/gestao.8da7e2a3.svg";